var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Silent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_214680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77384 6.22489C7.718 6.27057 7.64809 6.29553 7.57595 6.29553H6.4375C6.27174 6.29553 6.11277 6.36737 5.99556 6.49523C5.87835 6.6231 5.8125 6.79652 5.8125 6.97735V9.0228C5.8125 9.20363 5.87835 9.37706 5.99556 9.50492C6.11277 9.63279 6.27174 9.70462 6.4375 9.70462H7.57595C7.64809 9.70462 7.718 9.72958 7.77384 9.77526L9.67711 11.3325C9.88115 11.4994 10.1875 11.3543 10.1875 11.0906V4.90953C10.1875 4.6459 9.88115 4.50072 9.67711 4.66767L7.77384 6.22489Z",
    fill: "#474749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94061 11.4406L11.4406 3.94055L12.6843 5.18427L5.18433 12.6843L3.94061 11.4406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94061 11.4406L11.4406 3.94055L12.0593 4.55927L4.55933 12.0593L3.94061 11.4406Z",
    fill: "#474749"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_214680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Silent);
export default __webpack_public_path__ + "static/media/100-silent.f289a90ec6f545f5ee2254a0bb78955e.svg";
export { ForwardRef as ReactComponent };